// FILE: src/pages/ClientPortal/ClientVisits.jsx
import React, { useEffect, useState, useCallback } from 'react';
import { clientPortalAPI } from '../../api/services';
import { toast } from 'react-toastify';
import './ClientPortal.css';

const fmtDate = (d) => d ? new Date(d).toLocaleDateString('en-US',{year:'numeric',month:'short',day:'numeric'}) : '—';
const fmtTime = (d) => d ? new Date(d).toLocaleTimeString('en-US',{hour:'2-digit',minute:'2-digit'}) : '—';
const STATUSES = ['All','Scheduled','In Progress','Completed','Missed'];

function statusBadge(s) {
  const map = { Scheduled:'scheduled', Completed:'completed', 'In Progress':'inprogress', Missed:'missed' };
  return <span className={`cp-badge cp-badge-${map[s]||'default'}`}>{s||'—'}</span>;
}

export default function ClientVisits() {
  const [visits,  setVisits]  = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter,  setFilter]  = useState('All');
  const [search,  setSearch]  = useState('');

  const load = useCallback(async () => {
    try {
      const res = await clientPortalAPI.getVisits();
      setVisits(res.data.data || []);
    } catch { toast.error('Failed to load visits.'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const displayed = visits
    .filter(v => filter === 'All' || v.VisitStatus === filter)
    .filter(v => !search || (v.CaregiverName||'').toLowerCase().includes(search.toLowerCase()) || (v.ServiceName||'').toLowerCase().includes(search.toLowerCase()));

  return (
    <div className="cp-page">
      <div className="cp-header">
        <h1 className="cp-title">My Visit Schedule</h1>
        <p className="cp-subtitle">All your caregiver visits — past and upcoming</p>
      </div>

      {/* Search */}
      <input
        style={{ width:'100%', padding:'10px 14px', borderRadius:10, border:'1.5px solid #e5e7eb', marginBottom:16, fontSize:14, boxSizing:'border-box' }}
        placeholder="🔍 Search by caregiver or service..."
        value={search} onChange={e => setSearch(e.target.value)}
      />

      {/* Filter */}
      <div className="cp-filter-row">
        {STATUSES.map(s => (
          <button key={s} className={`cp-filter-btn ${filter===s?'active':''}`} onClick={() => setFilter(s)}>{s}</button>
        ))}
      </div>

      {loading ? <p style={{color:'#6b7280'}}>Loading visits…</p>
       : displayed.length === 0
       ? <div className="cp-empty"><div className="cp-empty-icon">📅</div><div className="cp-empty-text">No visits found</div></div>
       : displayed.map((v, i) => (
          <div key={v.ID||i} className="cp-card">
            <div className="cp-card-left">
              <div className="cp-card-name">🧑‍⚕️ {v.CaregiverName || '—'}</div>
              <div className="cp-card-meta">📅 {fmtDate(v.StartTime)}</div>
              <div className="cp-card-meta">🕐 {fmtTime(v.StartTime)} – {fmtTime(v.EndTime)}</div>
              {v.ServiceName && <div className="cp-card-meta">🏥 {v.ServiceName}</div>}
              {v.Notes       && <div className="cp-card-meta" style={{color:'#6b7280',fontStyle:'italic'}}>📝 {v.Notes}</div>}
            </div>
            <div className="cp-card-right">{statusBadge(v.VisitStatus)}</div>
          </div>
        ))
      }
    </div>
  );
}
